import { render, staticRenderFns } from "./HowToItem.vue?vue&type=template&id=a47ef39a&scoped=true&"
import script from "./HowToItem.vue?vue&type=script&lang=js&"
export * from "./HowToItem.vue?vue&type=script&lang=js&"
import style0 from "./HowToItem.vue?vue&type=style&index=0&id=a47ef39a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47ef39a",
  null
  
)

export default component.exports